module.exports = __webpack_public_path__ + "img/third_step.e6de734b.png";